export default {
  CORE: 'core',
  MARKETING: 'marketing',
  AI: 'ai',
  SEO: 'seo',
  SECURITY: 'security',
  MORE: 'more',
};
